import { formatAndBindToJSONToDayjs, getDateRange } from "../../utils"

const dateRange = getDateRange({start_date_difference: 7})

const initialState = {
  feedbackList: [],
  totalCount: 0,
  endDate: formatAndBindToJSONToDayjs(dateRange[1], "end"),
  startDate: formatAndBindToJSONToDayjs(dateRange[0]),
}

export default initialState
